import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EscalatorWarningIcon from '@mui/icons-material/EscalatorWarning';

const Recruitment = () => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (
        <>
            <div style={{ width: '80%', display: 'flex', margin:'auto', marginTop:'2rem', marginBottom:'1rem'}}>
                <EscalatorWarningIcon style={{ color: '#10609e' }}/>
                <p style={{ width: '80%', marginTop: '3px', marginLeft:'1rem', fontWeight:'bold', color:'#10609e'  }}>Recruitment and Response rates:</p><br />
            </div>
            <Accordion className='accordian_members' expanded={expanded === 'panel8'} onChange={handleChange('panel8')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What should I do if a parent or child withdraws from the study after giving consent?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ listStyleType: 'none' }}>
                            <li>Within your country's CloudStor folder, locate a file named "SUNRISEChecklist spreadsheet." This spreadsheet consists of three tabs. The third tab is designated for the
                                Data Collection team to record response rates for both rural and urban data collection. In the "Response Rate" sheet, please indicate the ID of the participant who has
                                withdrawn and provide the reason for their withdrawal.</li><br />
                            <li>If the parent or child has withdrawn from the entire study and no longer wishes for their data to be included, you must delete all their data.
                                Please also inform the Coordinating Centre so that they can remove the participants data from CloudStor, REDCap, and the EYToolbox database.</li><br />
                            <li>However, if the parent or child is happy with you keeping the data collected thus far, please retain the collected data and refrain from assessing the child using any additional measures.</li>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel9'} onChange={handleChange('panel9')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What should I do if a child, who has given consent, is sick on the days when we are at the Childcare centre for data collection?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        If a child is sick or absent on the days you are at the Childcare centre, please try to schedule another day to return to the centre when the child is present.
                        If you are unable to come back and gather data from this child, please add a note in the comments box provided in the REDCap instrument for that child. Indicate
                        that no further data will be collected for that child.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel21'} onChange={handleChange('panel21')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>How many children should I collect data from in each centre for the Main Study?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        A maximum of 25 children per centre should be collected in each centre for the Main Study.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel10'} onChange={handleChange('panel10')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What are some ways I can improve recruitment of children?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ marginLeft: '2rem' }}>
                            <li data-text="Visit the centres: ">Arrange meetings with parents or staff to discuss the study, generating enthusiasm about participation.</li>
                            <li data-text="Personal interactions: ">Take the opportunity during pick-up and drop-off times to explain the study to parents.</li>
                            <li data-text="Language support: ">Engage interpreters to communicate with parents who speak different languages.</li>
                            <li data-text="Centre staff involvement: ">If it aligns with ethical guidelines, encourage centre staff members to actively promote and discuss the
                                study with parents. This can be done through various means, such as displaying visual posters in the centre, utilizing email or other online
                                communication platforms used within the centre.</li>
                            <li data-text="Expand recruitment sources: ">Explore the possibility of recruiting children from various organizations.</li>
                            <li data-text="Incentives: ">If your budget allows and you can obtain ethics approval, consider offering a gift as compensation for participation.
                                This gift could take the form of a brief report on the children's performance (although this may require considerable time and effort) or a report on the
                                aggregated results of each centre. Alternatively, you could provide a physical gift for the participating child, such as a sticker or a ball.</li>
                            <li data-text="Marketing strategies: ">Implement marketing tactics like inviting journalists to cover and promote the SUNRISE study or creating a
                                short promotional video for sharing on social media and with centres to reach parents.</li>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel19'} onChange={handleChange('panel19')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>When should I collect the Test/Retest Parent Questionnaires?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        For the Pilot Study, we are asking countries to ask 10 parents (preferably 5 urban and 5 rural) to complete the parent questionnaire a second time 14 days
                        after the first was completed.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default Recruitment
